module.exports = __webpack_public_path__ + "static/media/left-arrow-grey.61753e19.svg";